import ClientComponent from '@/components/ClientComponent/ClientComponent';
import { BlogPost } from '@/typings/blog';
import { Locale } from '@/typings/locale';
import { Tag } from '@/typings/tag';
import { firebaseAdmin } from '@/utils/firebaseAdmin';
import BlogList from '@/views/BlogList/BlogList';
import dayjs from 'dayjs';
import { GetStaticProps } from 'next';
import { NextSeo } from 'next-seo';

type BlogDetailProps = {
  blogPosts: BlogPost[];
  tags: Tag[];
  locale: Locale;
};

function BlogDetail({ blogPosts, tags }: BlogDetailProps) {
  return (
    <>
      <NextSeo title="Prime Wine" />
      <ClientComponent>
        <BlogList blogPosts={blogPosts} tags={tags} />
      </ClientComponent>
    </>
  );
}

export const getStaticProps: GetStaticProps = async (context) => {
  const now = dayjs();

  const db = firebaseAdmin.firestore();
  const blogPostsCollection = db.collection('blogPosts');
  const { docs } = await blogPostsCollection
    .where('isPublished', '==', true)
    .where('deletedAt', '==', null)
    .get();

  const blogPosts: BlogPost[] = (docs || [])
    .map((doc) => {
      const publishedAt = doc.data().publishedAt;

      return {
        ...(doc.data() as BlogPost),
        id: doc.id,
        publishedAt: publishedAt ? publishedAt.toDate() : undefined,
      };
    })
    .filter((post) => (post.publishedAt ? now.isAfter(post.publishedAt) : false))
    .sort((a, b) => (dayjs(a.publishedAt).isBefore(dayjs(b.publishedAt)) ? 1 : -1));

  if (!blogPosts) {
    return {
      notFound: true,
    };
  }

  const tagsCollection = db.collection('tags');
  const { docs: tagDocs } = await tagsCollection.where('deletedAt', '==', null).get();

  const tags = tagDocs.map((doc) => ({ ...doc.data(), id: doc.id }));

  return {
    props: {
      blogPosts: JSON.parse(JSON.stringify(blogPosts)),
      tags: tags ? JSON.parse(JSON.stringify(tags)) : [],
      locale: context.locale,
    },
    revalidate: 2592000,
  };
};

export default BlogDetail;
